<!-- 海外产品介绍 -->
<template>
	<div class="aboutUs">
		<div class="imgBg"></div>
		<div class="boxWidth">
			<el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
				<el-tab-pane :label="item.label" :name="item.id" v-for="item in overseasTab" :key="item.id">
					<div  v-if="activeName == '1'">
						<div v-for="(item,index) in satelliteLists" :key="index" class="centerStyle">	
							<h2>{{item.level1}}</h2>
							<div v-for="(m,index2) in item.children" :key="index2">
								<h4>{{m.level2}}</h4>
								<div class="imgStyle">	
									<img :src="m.imgUrl" alt="">
								</div>
							</div>
						</div>
					</div>
					<div  v-if="activeName == '2'">
						<div v-for="(item,index) in GNSSLists" :key="index" class="GNSSCenter">
							<img :src="item.imgUrl" alt=""><br>
							<img src="../assets/img/overseas/GNSS04-2.png" alt="" v-if="item.type=='otherImg'">
							<div class="GNSS-table">
								<div class="GNSS-item">
									<div class="gnssItem itemtitle1">Category</div>
									<div class="gnssItem itemtitle2">Detail</div>
									<div class="gnssItem itemtitle3">Remarks</div>
								</div>
								<div class="GNSS-item" v-for="(i,index2) in item.children" :key="index2">
									<div class="gnssItem item1">{{i.categoryCon}}</div>
									<div class="gnssItem item2" v-html="i.detailCon"></div>
									<div class="gnssItem item3">{{i.markCon}}</div>
								</div>
							</div>
							
						</div>
					</div>
					<div  v-if="activeName == '3'">
						<div v-for="(item,index) in UAVLists" :key="index" class="GNSSCenter">
							<img :src="item.imgUrl" alt="">
							<div class="GNSS-table">
								<div class="GNSS-item" v-for="(i,index2) in item.children" :key="index2">
									<div class="gnssItem item1">{{i.leftCon}}</div>
									<div class="gnssItem item2" v-html="i.rightCon"></div>
								</div>
							</div>
							
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import data from '../assets/js/products'
	export default {
	  components: {},
	  data() {
	    return {
			activeName:'1',
			overseasTab:[
				{id:'1', label:'Satellite Data'},
				{id:'2', label:'GNSS'},
				{id:'3', label:'UAV'},
			],
			satelliteLists:data.satelliteLists,
			GNSSLists:data.GNSSLists,
			UAVLists:data.UAVLists,
		}
	  },
	  computed: {
			
		},
	  methods:{
		handleClick(){

		}
	  }
	}
</script>

<style scoped lang="scss">
  .imgBg{
	background-image: url('../assets/img/overseaBanner.jpg');
  }
  .uavStyle{
	img{
		width: 100%;
	}
  }
  .centerStyle{
	text-align: center;
	position: relative;
		h2{
			position: relative;
			margin-top:40px;
			margin-bottom: 20px;
		}
   }  
  .centerStyle::before{
		content:'';
		width:140px;
		height: 4px;
		border-radius: 2px;
		background:linear-gradient(to right ,#fff,#409eff);
		position:absolute;
		top:18px;
		left:28%;
	}
	.centerStyle::after{
		content:'';
		width:140px;
		height: 4px;
		border-radius: 2px;
		background:linear-gradient(to right ,#409eff,#fff);
		position:absolute;
		top:18px;
		right:28%;
	}
	.GNSSCenter{
		text-align: center;
		img{
			margin-top: 40px;
		}
	}
	.GNSS-table{
		width: 920px;
		margin: 0 auto;
		border-bottom: 1px solid #ddd;
		margin-top:20px;
	}
	.GNSS-item{
		display:flex;
		border-right: 1px solid #ddd;
		.gnssItem{
			text-align: center;
			border-left:1px solid #ddd;
			border-top:1px solid #ddd;
			padding: 10px 0px;
			color:#7c7c7c;
			
		}
		.item1,.itemtitle1{
			width: 260px;
			background-color: #f3f3f3;
		}
		.item2,.itemtitle2{
			flex: 1;
		}
		.item2{
			text-align: left;
			padding-left:10px;
		}
		.item3,.itemtitle3{
			width: 150px;
		}
		.itemtitle1,.itemtitle2,.itemtitle3{
			background-color: #409eff;
			color:#fff;
		}
	}
  .imgStyle{
	width:700px;
	margin: 0 auto;
	margin-top:10px;
	margin-bottom: 20px;
	img{
		width: 100%;
		
	}
  }
</style>